import { TranslateService } from "@ngx-translate/core";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { GestionContextService } from "../../context/getion-context.service";
import { GestionService } from "../../services/gestion.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService, UtilsService } from "shared-components";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-mantenimiento-marcas",
  templateUrl: "./mantenimiento-marcas.component.html",
})
export class MantenimientoMarcasComponent implements OnInit, OnDestroy {
  private _filters;
  public filtersVisible = false;
  public filtersForm: UntypedFormGroup;

  public marcas;

  public dropdownInfo: number;

  public mensajes = new Array<Message>();
  public showError: boolean;
  public deleteModal = false;
  public newEditModal = false;

  public itemsPerPage = 10;
  public currentPage = 0; // La paginación en back empieza por 0, como los arrays.
  public totalItems: number;
  public readonly visiblePages = 3;

  public toEditId;
  public toDeleteId;

  public etiquetaCaja;
  public etiquetaPallet;

  public orderBy: string;
  public columnId: number;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService,
    private readonly _gestionContextService: GestionContextService,
    private readonly _gestionService: GestionService,
    public readonly utilsService: UtilsService,
    private readonly _dataProvider: DataProvider,
    private readonly _translate: TranslateService
  ) {}

  ngOnInit() {
    this.filtersForm = this._fb.group({
      des: [""],
      alias: [""],
      fechaInicio: [""],
      fechaFin: [""],
      dateType: ["false"],
    });

    this._gestionContextService.mantenimientoMarcasFilters = null;

    this.getMarcas();

    this.filtersForm
      .get("fechaInicio")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.validDates());
    this.filtersForm
      .get("fechaFin")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.validDates());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public get etiquetas() {
    return this._dataProvider.etiquetas;
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  public showDetails(i: number, marca) {
    this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
    this.etiquetaCaja = marca.disenyoEtiquetaIdCaja
      ? this.etiquetas.find(
          (etiqueta) => etiqueta.id === marca.disenyoEtiquetaIdCaja
        ).des
      : "";
    this.etiquetaPallet = marca.disenyoEtiquetaIdPallet
      ? this.etiquetas.find(
          (etiqueta) => etiqueta.id === marca.disenyoEtiquetaIdPallet
        ).des
      : "";
    
    // Desplazamiento al principio del panel "Más información" para tablet (mismo tamaño máx. que en table.scss)
    if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
      // Retardo: en caso de que haya otro panel abierto
      setTimeout(() => {
        document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
      }, 50);
    }
  }

  public pageChange(page) {
    this.dropdownInfo = -1;
    this._gestionContextService.mantenimientoMarcasFilters.numPagina =
      this.currentPage = page - 1;
    this.getMarcas();
  }

  public itemsPerPageChange(items) {
    this.dropdownInfo = -1;
    this._gestionContextService.mantenimientoMarcasFilters.numPagina =
      this.currentPage = 0;
    this._gestionContextService.mantenimientoMarcasFilters = this.itemsPerPage =
      items;
    this.getMarcas();
  }

  public validDates() {
    if (
      this.filtersForm.get("fechaInicio").value &&
      this.filtersForm.get("fechaFin").value
    ) {
      if (
        this.checkDates(
          this.filtersForm.get("fechaInicio").value,
          this.filtersForm.get("fechaFin").value
        )
      ) {
        this.clearDatesValidators();
      } else {
        this.filtersForm.get("fechaInicio").setErrors(["Invalid date"]);
        this.filtersForm.get("fechaFin").setErrors(["Invalid date"]);
      }
      if (
        this.filtersForm.get("fechaInicio").invalid ||
        this.filtersForm.get("fechaFin").invalid
      ) {
        this.showError = true;
        this.mensajes.push({
          class: "error",
          message: "global.fecha.error.finAnteriorInicio",
        });
      } else {
        this.showError = false;
        this.mensajes = [];
      }
    } else {
      this.clearDatesValidators();
      this.showError = false;
      this.mensajes = [];
    }
  }

  private clearDatesValidators() {
    if (
      this.filtersForm.get("fechaFin").errors &&
      this.filtersForm.get("fechaFin").errors.includes("Invalid date")
    ) {
      this.filtersForm.get("fechaFin").clearValidators();
      this.filtersForm.get("fechaFin").updateValueAndValidity();
    }
    if (
      this.filtersForm.get("fechaInicio").errors &&
      this.filtersForm.get("fechaInicio").errors.includes("Invalid date")
    ) {
      this.filtersForm.get("fechaInicio").clearValidators();
      this.filtersForm.get("fechaInicio").updateValueAndValidity();
    }
  }

  private checkDates(inicio, fin) {
    const inicioD = new Date(inicio);
    const finD = new Date(fin);
    return inicioD <= finD;
  }

  public checkValuesForm(): boolean {
    return this.filtersForm.get("fechaInicio").value ||
      this.filtersForm.get("fechaFin").value ||
      this.filtersForm.get("des").value ||
      this.filtersForm.get("alias").value
      ? true
      : false;
  }

  public resetForm() {
    this.filtersForm.reset();
    this.filtersForm.get("dateType").patchValue("false");
  }

  public filtrar() {
    this.validDates();
    if (this.filtersForm.valid) {
      this.applyFilters();
    }
  }

  private applyFilters() {
    this.currentPage = 0;
    this._gestionContextService.mantenimientoMarcasFilters = {
      des: this.filtersForm.get("des").value
        ? this.filtersForm.get("des").value
        : "",
      alias: this.filtersForm.get("alias").value
        ? this.filtersForm.get("alias").value
        : "",
      fechaInicio: this.filtersForm.get("fechaInicio").value
        ? this.utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaInicio").value
          )
        : "",
      fechaFin: this.filtersForm.get("fechaFin").value
        ? this.utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaFin").value
          )
        : "",
      fechaActualizacion: this.filtersForm.get("dateType").value,
      cargaRegistroEnUso: true,
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage,
    };

    this.getMarcas();
  }

  public getMarcas() {
    if (this._gestionContextService.mantenimientoMarcasFilters) {
      this._filters = this._gestionContextService.mantenimientoMarcasFilters;
    } else {
      this.applyFilters();
    }
    this._spinnerService.showSpinner();
    this._gestionService
      .getMarcas(this._filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        this.totalItems = resp.paginacionMeta.totalCount;
        this.marcas = resp.lista;
      }, (error) => {
        this.showError = true;
        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
      });
  }

  public create() {
    this.toEditId = null;
    this.newEditModal = true;
  }

  public update(marca) {
    this.toEditId = marca.id;
    this.newEditModal = true;
  }

  public askDelete(marca) {
    this.toDeleteId = marca.id;
    this.deleteModal = true;
  }

  public delete() {
    this._spinnerService.showSpinner();
    this._gestionService
      .deleteMarca(this.toDeleteId)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then(() => {
        this.close();
        this.pushMessage("global.success.itemDeleted");
        this.getMarcas();
      });
  }

  public close() {
    this.deleteModal = false;
    this.newEditModal = false;
  }

  public refresh(value) {
    this.newEditModal = false;
    if (value) {
      this.getMarcas();
    }
  }

  public pushMessage(mensaje) {
    this.showError = true;
    this.mensajes.push({ class: "success", message: mensaje });
  }

  public getIcon(prop: string, idColumn: number) {
    let iconClass = "fa fa-sort";
    if (
      this._filters &&
      this._filters.orderItems &&
      this._filters.orderItems[0].orderProperty.indexOf(prop) != -1 &&
      this.columnId === idColumn
    ) {
      iconClass =
        this._filters.orderItems[0].orderByDescending === true
          ? "fa fa-sort-down"
          : "fa fa-sort-up";
    }
    return iconClass;
  }

  public toOrderBy(columnFilter, idColumn) {
    this.columnId = idColumn;
    if (this.marcas && this.marcas.length > 0) {
      if (this._gestionContextService.mantenimientoMarcasFilters) {
        this._filters = this._gestionContextService.mantenimientoMarcasFilters;
        if (!this.orderBy || this.orderBy.includes("DESC")) {
          this.orderBy = "ASC" + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: false,
            },
          ];
        } else if (this.orderBy.includes("ASC")) {
          this.orderBy = "DESC" + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: true,
            },
          ];
        }
        this.getMarcas();
      }
    }
  }

  public trackByMarcaId(index: number, marca: { id: number }): number {
    return marca.id;
  }
}
